import React, { useState, Fragment, useRef,  } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import cursos from "../../static/images/cursos_default.png";
import useOnceEffect from "../../Hooks/useOnceEffect";
import Loader from "../Loading/loading";
import cursosimg from "../../static/images/cursos_default.png";
import LinkButton from "../../utils/LinkButton";


function CursosRecomendados({ id, qty = 6 }) {
  const [items, setitems] = useState([]);

  let history = useHistory();
  const applicantId = localStorage.getItem("applicantId");

  useOnceEffect(() => {
    Carouselinner();
  });

  function Carouselinner() {
    axios
      .get("company-course/list-recomended-courses/" + applicantId)
      .then((result) => {
        LoadData(result.data);
      });
  }

  function LoadData(data = []) {
    let step = parseInt(qty);

    let arrItems = [];

    for (let index = 0; index <= data.length - 1; index) {
      let arr = data.slice(index, step);
      
      let carItem = (
        <div
          key={Math.floor(Math.random() * 1000)}
          data-bs-interval="1000000"
          className={parseInt(index) === 0 ? "carousel-item active" : "carousel-item"}
        >
          {arr.map((item, index) => {
            return (
              <div className="card-item">
                <div
                  className="item__wrapper d-flex justify-content-center"
                  onClick={() => redirectCourse(item.courseId)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    loading="lazy"
                    src={
                      item.fotoCurso != null
                        ? item.fotoCurso
                        : cursos
                    }
                    style={{ height: "149px" }}
                    alt={"curso" + index}
                  ></img>
                </div>
                <div className="item__name" style={{ textAlign: "center" }}>
                  {item.name}
                </div>
                <div className="item__views" style={{ textAlign: "center" }}>
                  <button className="btn-deg" onClick={() => redirectCourse(item.courseId)} style={{width: "fit-content", padding: ".5rem 2rem"}} >Ver Curso</button>
                </div>
              </div>
            );
          })}
        </div>
      );
      if (step + parseInt(qty) <= data.length) {
        index = step;
        step += parseInt(qty);
      } else {
        index = step;
        step = data.length;
      }
      arrItems.push(carItem);
    }

    setitems(arrItems);
  }

  

  const redirectCourse = (id) => {
    history.push("/user/DetalleCurso/" + id);
  };

  return (
    <div
      id={"carousel" + id}
      className="carousel__wrapper carousel-inner"
      data-interval="false"
    >
      <div className="carousel-inner">{items}</div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target={"#" + id}
        data-bs-slide="prev"
      ></button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target={"#" + id}
        data-bs-slide="next"
      ></button>
    </div>
  );
}


export function SlideCursos({id, qty = 3}) {


  const [indicators, setindicators] = useState([]);
  const [items, setitems] = useState([]);
  const [loading, setloading] = useState(true);
  const groups = useRef([])
  const applicantId = localStorage.getItem("applicantId");

  useOnceEffect(() => {
    Carouselinner();
  });

  function Carouselinner() {
    axios.get("company-course/list-recomended-courses/" + applicantId)
    .then((result) => {
      groups.current = result.data
      LoadData(groups.current);
    });
  }

  function LoadData(data) {
    let indice = 0;
    let step = parseInt(qty);
    let arrItems = [];

    for (let index = 0; index <= data.length - 1; index) {
      let arr = data.slice(index, step);


      let carItem = (
        <div
          key={Math.floor(Math.random() * 1000)}
          data-bs-interval="1000000"
          className={index === 0 ? "carousel-item active" : "carousel-item"}
        >
          {arr.map((item) => {

            return (
              <div key={item.id} className="card-item">
                <div className="card-container text-center">
                  <div className="card-logo border-gray">
                    <img
                      loading="lazy"
                      src={
                        item.fotoCurso
                          ? item.fotoCurso
                          : cursosimg
                      }
                      alt={"cursos_" + item.courseId}
                    />

                  </div>
                  <p>{item.name}</p>
                  <hr></hr>
                  <LinkButton
                    to={`/user/DetalleCurso/${item.courseId}`}
                    className="btn-deg"
                  >
                    Ver
                  </LinkButton>
                </div>
              </div>
            );
          })}
        </div>
      );

      if (step + parseInt(qty) <= data.length) {
        index = step;
        step += parseInt(qty);
      } else {
        index = step;
        step = data.length;
      }
      indice++;
      arrItems.push(carItem);
    }

    setitems([...arrItems]);
    LoadIndicators(indice - 1);
    setloading(false);
  }

  function LoadIndicators(data) {
    let arr = [];

    for (let index = 0; index <= data; index++) {
      let btn = (
        <button
          key={index}
          type="button"
          data-bs-target={"#carousel" + id}
          data-bs-slide-to={index}
          aria-label={"Slide " + (index + 1)}
          className={index === 0 ? "active" : ""}
        ></button>
      );
      arr.push(btn);
    }
    setindicators(arr);
  }

  return (
    <div
      id={"carousel" + id}
      className={loading ? "loader_container" : "carousel slide"}
      data-interval="false"
    >
      {loading ? (
        <Loader type="small"></Loader>
      ) : (
        <Fragment>
          <div className="carousel-inner">{items}</div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="prev"
          ></button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target={"#carousel" + id}
            data-bs-slide="next"
          ></button>
        </Fragment>
      )}
    </div>
  );
}

export default CursosRecomendados;
